import type { Locale } from "../../shared/i18n";

/** Fills `{name}` placeholders of a translated template. */
export function fill(
  template: string,
  values: Record<string, string | number>,
): string {
  return template.replace(/\{(\w+)\}/g, (match, name: string) =>
    name in values ? String(values[name]) : match,
  );
}

/** A calendar date for display; the raw value if unparseable. */
export function formatDate(locale: Locale, iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat(locale, { dateStyle: "long" }).format(date);
}

/** Date and time for a retry or expiry moment. */
export function formatDateTime(locale: Locale, iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat(locale, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
}

export const DELETION_WINDOW_DAYS = 30;

/** The day the purge would land if the request were made now. */
export function projectedPurge(now: Date = new Date()): string {
  return new Date(
    now.getTime() + DELETION_WINDOW_DAYS * 86_400_000,
  ).toISOString();
}
